import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { SelectList } from "../selectList";
import styles from "./styles.scss";
import { useSendActivityReport } from "@planzone/view-models";

const options = [
  "never",
  "everyLastDayOfMonth",
  "everyFifteenthDayOfMonth",
  "everySecondDayOfMonth",
  "everyFirstDayOfMonth",
  "everySaturday",
  "everyFriday",
  "everyThursday",
  "everyWednesday",
  "everyTuesday",
  "everyMonday",
  "everyTwoDays",
  "everyDay",
];

function ActivityReport({ preferences, edit }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, sendActivityReport } = useSendActivityReport();
  const selectOptions = options.map((option) => ({
    id: option,
    name: t(`preferences.activityReport.options.${option}`),
  }));
  const selectedOption = selectOptions.find(
    ({ id }) => id === preferences["notifications.mail.sendReportActivity"],
  );
  const extractOption = (opts: typeof selectOptions) =>
    opts.length > 0 ? opts[opts.length - 1].id : null;

  return (
    <div className={styles.activityReport}>
      <p
        className={styles.explanation}
        dangerouslySetInnerHTML={{
          __html: t("preferences.activityReport.explanation", {
            interpolation: { escapeValue: false },
          }),
        }}
      />
      <div className={styles.group}>
        <p className={styles.label}>{t(`preferences.activityReport.title`)}</p>
        <div className={styles.formWrapper}>
          <SelectList
            placeholder={t("preferences.activityReport.options.never")}
            options={selectOptions}
            selectedOptions={selectedOption ? [selectedOption] : []}
            selectItem={(selectedOptions) =>
              edit({
                ...preferences,
                ["notifications.mail.sendReportActivity"]:
                  extractOption(selectedOptions) || "",
              })
            }
          />
          <button
            className={styles.button}
            onClick={() => !isRequestPending && sendActivityReport()}
          >
            {t("preferences.activityReport.sendReport")}
          </button>
        </div>
      </div>
    </div>
  );
}

export { ActivityReport };
